<div class="container">
    <div class="row">
        <div class="col-12">
            <h4 mat-dialog-title>Détail de l'import {{ import.Id}} - Ligne {{ detail.Id }}</h4>
            <hr>
        </div>
    </div>
    <div class="row">
        <div class="col-3 label">
            Etat
        </div>
        <div class="col-2 label-sub">
            Validité
        </div>
        <div class="col-2">
            <span *ngIf="detail.IsValid" class="material-icons" tooltip="Valide">
                check
            </span>
            <span *ngIf="!detail.IsValid" class="material-icons" tooltip="Erreur">
                not_interested
            </span>
        </div>
        <div class="col-2 label-sub" *ngIf="detail.IsValid">
            Facture
        </div>
        <div class="col-2" *ngIf="detail.IsValid">
            <span *ngIf="detail.IsOcrMetadataImported" class="material-icons" tooltip="Facture">
                check
            </span>
            <span *ngIf="!detail.IsOcrMetadataImported" class="material-icons" tooltip="En attente de traitement">
                not_interested
            </span>
        </div>
    </div>
    <div class="row">
        <div class="col-3 label">
            Date d'import
        </div>
        <div class="col-9">
            {{ import.ImportDate | date:'dd/MM/yyyy HH:mm:ss' }}
        </div>
    </div>
    <div *ngIf="detail.RecoveryDate" class="row">
        <div class="col-3 label">
            Date de récupération
        </div>
        <div class="col-9">
            {{ detail.RecoveryDate | date:'dd/MM/yyyy HH:mm:ss' }}
        </div>
    </div>
    <div class="row" *ngIf="detail.OcrMetadataId">
        <div class="col-3 label">
            ID Facture
        </div>
        <div class="col-9">
            {{detail.OcrMetadataId}}
        </div>
    </div>
    <div class="row" *ngIf="detail.JsonFileName">
        <div class="col-3 label">
            Fichier JSON
        </div>
        <div class="col-9">
            {{detail.JsonFileName}}
        </div>
    </div>
    <div class="row" *ngIf="detail.PdfFileName">
        <div class="col-3 label">
            Fichier PDF
        </div>
        <div class="col-9">
            {{detail.PdfFileName}}
        </div>
    </div>
    <div class="row" *ngIf="!detail.IsValid">
        <div class="col-3 label">
            Erreur
        </div>
        <div class="col-9">
            {{detail.ErrorType}}
        </div>
    </div>
    <div class="row" *ngIf="!detail.IsValid">
        <div class="col-3 label">
            Message d'erreur
        </div>
        <div class="col-9">
            {{detail.Error}}
        </div>
    </div>
    <div class="row" *ngIf="detail.JsonContent && detail.JsonContent.length > 0">
        <div class="col-3 label">
            Contenu du JSON
        </div>
        <div class="col-9">
            <textarea readonly cols="80" rows="8">
                {{detail.JsonContent}}
            </textarea>
        </div>
    </div>
    <div class="row" *ngIf="detail.HasPdfContent">
        <div class="col-3 label">
            Contenu du PDF
        </div>
        <div class="col-9">
            <span class="material-icons" tooltip="Télécharger" (click)="onPdf()">
                picture_as_pdf
            </span>
        </div>
    </div>
</div>

<div class="d-flex justify-content-end">
    <div class="col-2">
        <button type="button" tooltip="Fermer" class="btn btn-secondary btn-sm btn-block"
            (click)="close()">Fermer</button>
    </div>
</div>